module.exports = __webpack_public_path__ + "static/img/down_img05.png.e84df0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sptj/down_img05.png.png
// module id = qBEF
// module chunks = 1